;(function($){

  $(window).ready(init);

  function init() {
    var ARCHIVEINTRO = '.ArchiveIntro--size';

    function giveIntroHeight(){
      var windowHeight = $(window).height();
      $(ARCHIVEINTRO).css('min-height' , windowHeight - 80) ;
    }


    giveIntroHeight();

    $(window).on('resize', function(){
      giveIntroHeight()
    })
  }

})(jQuery);
